import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation }           from '@/i18n/useTranslation'
import { getTitleKey, PATHS }       from '@/lib/routes'
import { useMobileHeaderStore }     from '@/store/mobile-header-store'

// Routes where the MobileHeader is not shown (they have their own navigation).
export const MOBILE_HEADER_HIDDEN_PATHS: string[] = [
  PATHS.dashboard,
  PATHS.transactions,
  PATHS.balances,
  PATHS.moreOptions,
]

export function useMobileHeader() {
  const { t }        = useTranslation('layout')
  const { pathname } = useLocation()
  const navigate     = useNavigate()
  const actions      = useMobileHeaderStore(s => s.actions)
  const backAction   = useMobileHeaderStore(s => s.backAction)

  const hidden = MOBILE_HEADER_HIDDEN_PATHS.includes(pathname)

  const title      = t(getTitleKey(pathname))
  const handleBack = backAction ?? (() => navigate(-1))

  return { hidden, title, handleBack, actions, backLabel: t('layout.nav.back') }
}
